import React, { useState } from 'react';
import { Typography, Chip, Alert } from '@mui/material';
import { Game } from '../../../../interfaces/Games.interface';
import { getCompetitionCoverage } from '../../../../services/util/bc/getCompetitionCoverage';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  StyledBox,
  StyledChipBox,
  StyledCompetitionSpan,
  StyledContainer,
  StyledPaper,
  StyledSpan,
} from './BCCompetitions.styled';
import { Cancel } from '@mui/icons-material';
import { LiveOrHighlightOrBoth } from '../providerXcompetitonsXgames/types/HighlightOrLiveOrBoth.types';

type BCCompetitionsProps = {
  competitions: string[];
  gamesFromSelectedTeams: Game[];
  totalCoveredGames: Game[];
  totalCoveredGames_HIGHLIGHT: Game[];
  mode: LiveOrHighlightOrBoth;
};

const BCCompetitions: React.FC<BCCompetitionsProps> = ({
  competitions,
  gamesFromSelectedTeams,
  totalCoveredGames,
  totalCoveredGames_HIGHLIGHT,
  mode,
}) => {
  const MAX_COMPETITIONDISPLAY = 5;
  const [showMore, setShowMore] = useState(false);

  const isShowMoreActive = competitions.length > MAX_COMPETITIONDISPLAY;
  const displayedCompetitions = showMore
    ? competitions
    : competitions.slice(0, MAX_COMPETITIONDISPLAY);

  const hasUnstreamedCompetition = competitions.some(
    (competition) =>
      getCompetitionCoverage(
        competition,
        gamesFromSelectedTeams,
        totalCoveredGames
      ) === 'NONE'
  );

  const handleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      {competitions.length > 0 && (
        <StyledContainer>
          <StyledPaper elevation={3}>
            <Typography variant="h5" gutterBottom>
              Competitions
            </Typography>
            {hasUnstreamedCompetition && (
              <Alert severity="warning" color="warning">
                Your selected teams play in competitions that are not streamed
                by any provider!
              </Alert>
            )}
            <br />
            <StyledBox>
              {mode === 'Default' && (
                <>
                  <StyledSpan>Live</StyledSpan>
                  <StyledSpan>Highlight</StyledSpan>
                  <StyledSpan>Competition</StyledSpan>
                </>
              )}
            
            </StyledBox>
            {displayedCompetitions.map((competition) => {
              const status_LIVE = getCompetitionCoverage(
                competition,
                gamesFromSelectedTeams,
                totalCoveredGames
              );
              const status_HIGHLIGHT = getCompetitionCoverage(
                competition,
                gamesFromSelectedTeams,
                totalCoveredGames_HIGHLIGHT
              );

              let icon;
              let icon_HIGHLIGHT;

              switch (status_LIVE) {
                case 'FULL':
                  icon = <CheckCircleIcon color="success" />;
                  break;
                case 'PARTIAL':
                  icon = <CheckCircleIcon color="warning" />;
                  break;
                case 'NONE':
                  icon = <Cancel color="disabled" />;
                  break;
                default:
                  icon = null;
              }
              switch (status_HIGHLIGHT) {
                case 'FULL':
                  icon_HIGHLIGHT = <CheckCircleIcon color="success" />;
                  break;
                case 'PARTIAL':
                  icon_HIGHLIGHT = <CheckCircleIcon color="warning" />;
                  break;
                case 'NONE':
                  icon_HIGHLIGHT = <Cancel color="disabled" />;
                  break;
                default:
                  icon_HIGHLIGHT = null;
              }

              return (
                <StyledBox key={competition}>
                  {mode === 'Default' && (
                    <>
                      <StyledSpan>{icon}</StyledSpan>
                      <StyledSpan>{icon_HIGHLIGHT}</StyledSpan>
                    </>
                  )}
                  {mode === 'Live' ? (
                    <StyledSpan>{icon}</StyledSpan>
                  ) : mode === 'Highlight' ? (
                    <StyledSpan>{icon_HIGHLIGHT}</StyledSpan>
                  ) : null}

                  <StyledCompetitionSpan>{competition}</StyledCompetitionSpan>
                </StyledBox>
              );
            })}

            {isShowMoreActive && !showMore && (
              <StyledChipBox>
                <Chip
                  label="Show More"
                  onClick={handleShowMore}
                  clickable
                  color="primary"
                />
              </StyledChipBox>
            )}

            {showMore && (
              <StyledChipBox>
                <Chip
                  label="Show Less"
                  onClick={handleShowMore}
                  clickable
                  color="primary"
                />
              </StyledChipBox>
            )}
          </StyledPaper>
        </StyledContainer>
      )}
    </>
  );
};

export default BCCompetitions;